// 聊天接口
import { ChatInterface } from '@/types/chatInterface';
import { get, post, put, del } from './request';
import { Message } from '@/components/AiChat';

// 创建新对话
const CreateNewChatPath = '/api/v1/chats';
export const createNewChat = (
	data: ChatInterface
) => post(CreateNewChatPath, data);

// 删除对话
export const deleteChat = (id: string) => del(`/api/v1/chats/${id}`);

// 获取对话详情
export const getChatDetail = (id: string) => get(`/api/v1/chats/${id}`);

// 更新对话标题
export const updateChat = async (data: {
  id: string;
  title: string;
}) => put(`/api/v1/chats/${data.id}`, data);

// 获取对话历史
export const getChatHistory = async (params: { 
  page?: number;
  pageSize?: number;
  searchText?: string;
}) => get('/api/v1/chats', { params });

// 发送消息
export const sendMessage = (data: {
  message: string;
  chatId?: string;
  model: string;
}) => post('/api/v1/chat', data); 

// 更新对话消息
export const updateChatMessages = (data: {
  chatId: string;
  messages: Message[];
}) => put(`/api/v1/chats/${data.chatId}`, { messages: data.messages });